export const isInElectron = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes(' electron/');
export const isWebClient = process.env.REACT_APP_CLIENT_HOST === 'WEB';
